__webpack_require__.p = "/device-detector-js/";